import React, { useContext, useState } from 'react';
import { getLabel } from '../data/labels';
import { getFirstLine } from '../common/UOBox';
import { useWidgets } from '../common/WidgetsProvider';
import PrematchContext from '../contexts/PrematchContext';
import { classIf, filterBetsByNumberOfOdds, filtraParametriche, getBetDescription, iconCategoryCssClass, iconSportCssClass, nullOrEmptyObj } from '../data/utils';
import { usePrematchData } from '../prematch/PrematchDataFetcher';
import Odd from './Odd';

function TopMatchesContent(props) {
    const prematchContext = useContext(PrematchContext);
    const prematchData = usePrematchData();
    
    const data = props.data;
    const [selectedSport, setSelectedSport] = useState(0);

    const tournaments = data[selectedSport];

    return (
        <>
            <div className="section-title">
                <span className="title">{getLabel('prematch_page.widget.top_match')}</span>
                <div className="sport-switcher">
                    {data.map((tournaments, sportIndex) => {
                        const sportId = tournaments[0][0].sportRef;

                        function handleClick() {
                            setSelectedSport(sportIndex);
                        }

                        const sport = prematchData.sportById[sportId];
                        const desc = sport.descrizione;
                        const icoSport = iconSportCssClass(sport.id, sport.iconClass);
                        // const count = data.matchesBySport[sportId].length;

                        return (
                            <div key={sportId} className={"selection-item" + classIf(selectedSport === sportIndex, 'active')} onClick={handleClick}>
                                <div className={"icona-sport ico-sport " + icoSport}></div>
                                <span className="selection-item-desc">{desc}</span>
                                {/* <div className="counter">{count}</div> */}
                            </div>
                        );
                    })}
                </div>
            </div>
            {tournaments.map(matches => {
                const betsDescs = [];
                const renderedMatches = matches.map((m, i) => {
                    function handleClick() {
                        const tournamentUniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
                        prematchContext.openEvent(tournamentUniqueId, m);
                    }
            
                    let bets = filtraParametriche(m.bets);
                    bets = filterBetsByNumberOfOdds(bets);
            
                    return (
                        <React.Fragment key={m.id}>
                            <div className="match">
                                <div className="left-section">
                                    <div className="time">
                                        <span>{m.dateShort}</span>
                                        <span>{m.time}</span>
                                    </div>
                                    <div className="info">
                                        <div className="teams-inline" onClick={handleClick}>
                                            <div className="team-home">
                                                <span>{m.team1}</span>
                                            </div>
                                            <div className="vs">-</div>
                                            <div className="team-away">
                                                <span>{m.team2}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="odds">
                                    {bets.map((b, betIndex) => {
                                        const isParametrica = b.parametrica;
                                        if (isParametrica) {
                                            b = getFirstLine(m.betsById.get(b.id));
                                        }
            
                                        const oddsDescs = [];
                                        const renderedOdds = [];
                                        b.odds.forEach(odd => {
                                            const id = `${b.uniqueId}_${odd.uniqueId}`;
                                            if (i === 0) {
                                                oddsDescs.push(
                                                    <span key={id} className="odd-desc">{odd.desc}</span>
                                                );
                                            }
            
                                            renderedOdds.push(
                                                <Odd key={id} data={odd} />
                                            );
                                        });
            
                                        let nCols = b.odds.length;
                                        if (isParametrica) {
                                            nCols++;
                                        }
            
                                        const isEven = betIndex % 2 === 0;
            
                                        if (i === 0) {
                                            betsDescs.push(
                                                <div key={b.id} className="bets-header-item" data-odds={nCols}>
                                                    <div className={"bet-desc-container" + classIf(isEven, 'lighter')}>
                                                        <span className="bet-desc">{getBetDescription(b, true, m.sportRef)}</span>
                                                    </div>
                                                    <div className="odds-descs">
                                                        {isParametrica &&
                                                            <span className="odd-desc">{b.handicapTableDesc}</span>
                                                        }
                                                        {oddsDescs}
                                                    </div>
                                                </div>
                                            );
                                        }
            
                                        return (
                                            <React.Fragment key={b.id}>
                                                {isParametrica &&
                                                    <div className={"bet" + classIf(isEven, 'lighter')}>
                                                        <span className="odd">{b.handicapDesc !== '' && b.handicapDesc !== '0' ? b.handicapDesc : <i className="fa fa-lock"></i>}</span>
                                                    </div>
                                                }
                                                <div className={"bet" + classIf(isEven, 'lighter')}>
                                                    {renderedOdds}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        </React.Fragment>
                    );
                });

                const m = matches[0];
                const categoryIcon = iconCategoryCssClass(m.sportRef, m.categoryRef, m.categoryIcon);

                return (
                    <div key={m.tournamentRef} className="last-minute">
                        <div className="matches-container">
                            <div className="bets-header">
                                <div className="info-column-header">
                                    <div className="sport-desc">
                                        <div className={"sport-icon " + categoryIcon} />
                                        <span>{matches[0].categoryDesc} - {matches[0].tournamentDesc}</span>
                                    </div>
                                    <div className="sub-header">
                                        <div className="time"></div>
                                        <div className="info"></div>
                                    </div>
                                </div>
                                <div className="bets-header-descs">{betsDescs}</div>
                            </div>
                            {renderedMatches}
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default function TopMatches() {
    const prematchData = usePrematchData();
    const data = useWidgets();

    if (data == null || nullOrEmptyObj(data.topMatches)) {
        return null;
    }

    const sportsMap = new Map();
    data.topMatches.forEach(m => {
        if (!sportsMap.has(m.sportRef)) {
            sportsMap.set(m.sportRef, new Map());
        }

        const tMap = sportsMap.get(m.sportRef);

        const uniqueId = `${m.sportRef}_${m.categoryRef}_${m.tournamentRef}`;
        if (!tMap.has(uniqueId)) {
            tMap.set(uniqueId, []);
        }
        
        try {
            m.cRanking = prematchData.sportById[m.sportRef].categoryById[m.categoryRef].ranking;
            m.tRanking = prematchData.tournamentByUniqueId[uniqueId].ranking;
            tMap.get(uniqueId).push(m);
        } catch (e) {
            console.error(e);
        }
    });

    const sports = [];
    try {
        sportsMap.forEach(tMap => {
            const tournaments = Array.from(tMap.values());
            tournaments.sort((a, b) => {
                const [aMatch, bMatch] = [a[0], b[0]];
                if (aMatch.cRanking === bMatch.cRanking) {
                    if (aMatch.tRanking === bMatch.tRanking) {
                        return aMatch.timestampDB.localeCompare(bMatch.timestampDB);
                    }
                    return aMatch.tRanking - bMatch.tRanking;
                }
                return aMatch.cRanking - bMatch.cRanking;
            });

            // Sort matches by timestamp
            tournaments.forEach(matchesArray => {
                matchesArray.sort((a, b) => a.timestamp - b.timestamp);
            });
            sports.push(tournaments);
        });

        const sportById = prematchData.sportById;
        sports.sort((a, b) => {
            const [aSportId, bSportId] = [a[0][0].sportRef, b[0][0].sportRef];
            const aRanking = sportById[aSportId].ranking;
            const bRanking = sportById[bSportId].ranking;
            return aRanking - bRanking;
        });
    } catch(e) {
        console.error(e);
    }

    return (
        <TopMatchesContent data={sports} />
    );
}
